//using standard ISO-639 https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
import { HtmlDetailData } from "./base.model";

export interface Translations {
  [key: string]: { [key: string]: string | HtmlDetailData };
}

export const staticTextMap: { [key in string]: { [key in string]: string } } = {
  en: {
    start: "Start",
    complete: "Complete",
    completed: "Completed",
    next: "Next",
    trialDay: "Trial Day",
    phone: "Phone",
    back: "Back",
  },
  de: {
    start: "Los",
    complete: "Fertig",
    completed: "Fertiggestellt",
    next: "Weiter",
    trialDay: "Testphase",
    phone: "Telefonnr",
    back: "Zurück",
  },
  fr: {
    start: "Démarrer",
    complete: "Terminé",
    completed: "Terminé avec succès",
    next: "Suivant",
    trialDay: "Jour d'essai",
    phone: "numTel",
    back: "Retour",
  },
};
